import carousel from './components/carousel'

carousel.initCarousel()
